import { Component, OnInit, OnDestroy } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';

import { UserService } from '../core/user.service';
import { AuthService } from '../core/auth.service';
import { OrderService } from './order.service';
import { FirebaseUserModel } from '../core/user.model';
import { Library } from '@core/library';
import { pattern } from '@config/pattern';

@Component({
  selector: 'app-page-order',
  templateUrl: 'order.component.html',
  styleUrls: ['styles.scss']
})
export class OrderComponent implements OnInit, OnDestroy {

  user: FirebaseUserModel = new FirebaseUserModel();
  sub: Subscription;
  orderForm: FormGroup;
  formSubmitAttempt = false;
  hiddenAlert = true;

  constructor(
    public userService: UserService,
    public authService: AuthService,
    private orderService: OrderService,
    private route: ActivatedRoute,
    private fb: FormBuilder,
    private library: Library,
  ) {}

  isFieldInvalid(field: string, typeError: string) {
    if (this.formSubmitAttempt && this.orderForm.get(field).invalid) {
        return this.orderForm.get(field).hasError(typeError);
    }

    if (this.orderForm.get(field).invalid && (this.orderForm.get(field).touched)) {
      return this.orderForm.get(field).hasError(typeError);
    }
  }

  ngOnInit(): void {

    this.sub = this.route.data.subscribe(routeData => {
      const data = routeData.data;
      if (data) {
        this.user = data;
        this.createForm();
      }
    });
  }

  createForm() {
    this.orderForm = this.fb.group({
      road: new FormControl('', Validators.required),
      content: new FormControl ('', Validators.required),
      phone: new FormControl('', [
        Validators.required,
        Validators.pattern(pattern.phoneNumber)
      ]),
    });
  }

  showAlert() {
    this.hiddenAlert = false;
  }

  hideAlert() {
    this.hiddenAlert = true;
  }

  resetForm() {
    this.orderForm.reset();
    this.formSubmitAttempt = false;
    // this.orderForm.get('phone').setValue(this.user.phone);
    // this.orderForm.get('phone').updateValueAndValidity();
    this.orderForm.markAsUntouched();
  }

  onSubmit() {
    this.formSubmitAttempt = true;
    if (this.orderForm.invalid) {
      return;
    }

    this.library.showloading();
    const formData = this.orderForm.value;
    this.orderService.add(formData, this.user).then((order) => {
      this.resetForm();
      this.showAlert();
    }).finally(() => {
      this.library.hideloading();
    });
  }

  ngOnDestroy() {
    this.sub.unsubscribe();
  }
}
